import React, { useEffect, useState } from "react";
import { withRouter } from "utilities/withRouter";
import "./groupInformation.css";

import validateQuote from "modules/createQuote/validateQuote";

import GroupType from "../groupType/groupType";
import GroupName from "../groupName/groupName";
import GroupNoOfTravellers from "../groupNoOfTravellers/groupNoOfTravellers";
import EventType from "../eventType/eventType";
import { CONSTANTS } from "utilities/constants";

function GroupInformation(props) {

    const [selectedGroupType, setSelectedGroupType] = useState(null);
    const [selectedEventType, setSelectedEventType] = useState(null);

    let { quote, handleStep1Data, errors, groupTypes, groupEventAvailable } = props;

    let groupInformation = quote?.groupInformation ?? {};

    if (!groupInformation) {
        return null;
    }
    
    const handleGroupTypeChange = (groupType) => {

        const data = {
            target: {
                value: groupType ? groupType.code : "",
                name: "groupType"
            }
        };

        handleStep1Data(data);
        validateQuote.isGroupTypeValid(quote, errors, props.localize);

        if(!selectedGroupType || selectedGroupType.code !== groupType.code) {
            const defaultEventType = groupType?.events?.find(s => s.code === CONSTANTS.NO_PLANNING_SERVICE_REQUIRED);
            setSelectedEventType(defaultEventType);
            handleGroupEventChange(defaultEventType);
            setSelectedGroupType(groupType);
        }
    };

    const handleGroupEventChange = (eventType) => {
        setSelectedEventType(eventType);
        let { handleStep1Data } = props;

        const data = {
            target: {
                value: eventType ? eventType.code : "",
                name: "eventName"
            }
        };
        handleStep1Data(data);
    };

    const handleEventDetailsChange = (event) => {
        let { handleStep1Data } = props;
        const data = {
            target: {
                value: event.target.value,
                name: "eventDetails"
            }
        };
        handleStep1Data(data);
    };

    let { groupName, groupType, eventName, noOfTravellers, eventDetails } = groupInformation || {};

    useEffect(() => {
        //console.log(groupTypes, groupType, eventName);
        if(groupTypes?.data && groupTypes?.data.length > 0 && groupType) {
            const _groupType = groupTypes?.data?.find(s => s.code === groupType);
            // console.log(_groupType);
            if(_groupType) {
                setSelectedGroupType(_groupType);
                if(eventName && groupEventAvailable) {
                    const _event = _groupType?.events?.find(s => s.code === eventName);
                    // console.log(eventName);
                    if(_event) {
                        setSelectedEventType(_event);
                    }
                }
            }
        }
    }, []);

    return (
        <div className="group-information-container">

            <div className="row font-bold margin-bottom-2x font-22">
                {props.localize("qma-group-information-header")}
            </div>

            <div className="row responsive">
                <div className="col-3">
                    <GroupName
                        quote={quote}
                        errors={errors}
                        groupName={groupName}
                        error={errors?.groupName}
                        handleStep1Data={handleStep1Data} />
                </div>

                <div className="col-3">
                    <GroupType groupTypes={groupTypes} quote={quote} errors={errors} groupType={groupType} error={errors?.groupType} handleGroupTypeChange={handleGroupTypeChange} groupEventAvailable={groupEventAvailable}/>
                </div>

                <div className="col-3-no-margin-r">
                    <GroupNoOfTravellers quote={quote} errors={errors} noOfTravellers={noOfTravellers} error={errors?.noOfTravellers} handleStep1Data={handleStep1Data} />
                </div>
            </div>
            {
                groupEventAvailable ? <EventType quote={quote} eventDetails={eventDetails} selectedGroupType={selectedGroupType} selectedEventType={selectedEventType} errors={errors} error={errors?.eventName} handleGroupEventChange={handleGroupEventChange} handleEventDetailsChange={handleEventDetailsChange} /> : null
            }
        </div>
    );
}

export default withRouter(GroupInformation);